module.exports = __webpack_public_path__ + "static/media/_liechtenstein.fb3eed41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_liechtenstein.svg
// module id = 2334
// module chunks = 7